import { Injectable } from '@angular/core';

export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}

const NavigationItemsGestao = [
  {
    id: 'navigation',
    title: 'Perfil Valor e Saúde',
    type: 'group',
    icon: 'feather icon-align-left',
    children: [
      {
        id: 'home-gestao',
        title: 'Home',
        type: 'item',
        url: '/home-gestao',
        classes: 'nav-item',
        icon: 'feather icon-home'
      },      
      {
        id: 'usuarios',
        title: 'Usuários',
        type: 'collapse',
        url: '/home',
        classes: 'nav-item',
        icon: 'feather icon-user',
        children: [           
          {
            id: 'cadastro-usuario-gestao',
            title: 'Cadastrar',
            type: 'item',
            url: '/cadastro-usuario-gestao',
            classes: 'nav-item',
            //icon: 'feather icon-sidebar'
          }
        ]
      },
      {
        id: 'clientes',
        title: 'Clientes',
        type: 'collapse',
        url: '/clientes',
        classes: 'nav-item',
        icon: 'feather icon-user',
        children: [ 
          {
            id: 'pre-cadastro-cliente',
            title: 'Pré-Cadastro',
            type: 'item',
            url: '/pre-cadastro-cliente',
            classes: 'nav-item',
            //icon: 'feather icon-sidebar'
          },
          {
            id: 'cadastro-cliente-gestao',
            title: 'Cadastrar',
            type: 'item',
            url: '/cadastro-cliente-gestao',
            classes: 'nav-item',
            //icon: 'feather icon-sidebar'
          }
        ]
      },
      {
        id: 'auditoria',
        title: 'Auditoria',
        type: 'collapse',
        url: '/auditoria',
        classes: 'nav-item',
        icon: 'feather icon-sidebar',
        children: [ 
          {
            id: 'auditoria',
            title: 'Visualizar',
            type: 'item',
            url: '/auditoria',
            classes: 'nav-item',
          },
          {
            id: 'cronograma-teste',
            title: 'Cronograma Base',
            type: 'item',
            url: '/cronograma-teste',
            classes: 'nav-item',
          },
          {
            id: 'cronograma-cliente',
            title: 'Cronograma Cliente',
            type: 'item',
            url: '/cronograma-cliente',
            classes: 'nav-item'
          }
        ]
      }
    ]

  },
  {
    id: 'conteudo',
    title: 'Conteúdo',
    type: 'collapse',  
    icon: 'feather icon-edit',   
    children: [       
      {
        id: 'cadastro-triagem',
        title: 'Cadastro',
        type: 'item',
        url: '/cadastro-triagem',
        classes: 'nav-item',
        //icon: 'feather icon-sidebar'
      },

      {
        id: 'pesquisa-triagem',
        title: 'Pesquisa',
        type: 'item',
        url: '/pesquisa-triagem',
        classes: 'nav-item',
        //icon: 'feather icon-sidebar'
      },
      {
        id: 'cadastro-questao',
        title: 'Cad. Requisitos',
        type: 'item',
        url: '/cadastro-questao',
        classes: 'nav-item',
        //icon: 'feather icon-sidebar'
      },
      {
        id: 'pesquisa-questao',
        title: 'Pesq. Requisitos',
        type: 'item',
        url: '/pesquisa-questao',
        classes: 'nav-item',
        //icon: 'feather icon-sidebar'
      },
      {
        id: 'cadastro-escala',
        title: 'Grupo Requisitos',
        type: 'item',
        url: '/cadastro-escala',
        classes: 'nav-item',
        //icon: 'feather icon-sidebar'
      },

    ]

  },
  {
    id: 'Relatórios',
    title: 'Relatórios',
    type: 'collapse',  
    icon: 'feather icon-activity', 
    children: [ 
      {
        id: 'GeracaoRElatorios',
        title: 'Geração de Relatórios',
        type: 'item',
        url: '/GeracaoRElatorios',
        classes: 'nav-item',
      },

    ]

  },
  {
    id: 'comunicacao',
    title: 'Comunicação',
    type: 'item',  
    icon: 'feather icon-message-circle', 
    url: '/comunicacaoCidadania',
    

  },
  {
    id: 'agendamento',
    title: 'Agenda',
    type: 'item',  
    icon: 'feather icon-calendar', 
    url: '/agendamento',   

  },
  {
    id: 'Suporte',
    title: 'Suporte',
    type: 'collapse',  
    icon: 'feather icon-message-square', 
    children: [ 
      {
        id: 'Solicitar suporte',
        title: 'Solicitar suporte',
        type: 'item',
        url: '/Solicitar suporte',
        classes: 'nav-item',
      },

      {
        id: 'Manual de Preparação para Auditorias',
        title: 'Manual de Preparação para Auditorias',
        type: 'item',
        url: '/Manual de Preparação para Auditorias',
        classes: 'nav-item',
      }
    ]

  },{
    id: 'Configurações',
    title: 'Configurações',
    type: 'collapse',  
    icon: 'feather icon-settings', 
    children: [ 
      {
        id: 'Gerenciar Usuários',
        title: 'Gerenciar Usuários',
        type: 'item',
        url: '/Gerenciar Usuários',
        classes: 'nav-item',
      },

      {
        id: 'Configurações de Notificações',
        title: 'Configurações de Notificações',
        type: 'item',
        url: '/Configurações de Notificações',
        classes: 'nav-item',
      },
      {
        id: 'Personalização do Perfil',
        title: 'Personalização do Perfil',
        type: 'item',
        url: '/Personalização do Perfil',
        classes: 'nav-item',
      }

    ]

  }

];

const NavigationItemsOperadora = [
  {
    id: 'navigation',
    title: 'Perfil Operadora',
    type: 'group',
    icon: 'feather icon-align-left',
    children: [
      {
        id: 'home-operadora',
        title: 'Home',
        type: 'item',
        url: '/home-operadora',
        classes: 'nav-item',
        icon: 'feather icon-home'
      },
      {
        id: 'cadastro-usuario-operadora',
        title: 'Usuarios',
        type: 'item',
        url: '/cadastro-usuario-operadora',
        classes: 'nav-item',
        icon: 'feather icon-user'
      },      
      {
        id: 'parceiro',
        title: 'Parceiros',
        type: 'collapse',
        url: '/parceiro',
        classes: 'nav-item',
        icon: 'feather icon-users',
        children: [ 
          {
            id: 'pre-cadastro-cliente',
            title: 'Pré-Cadastro',
            type: 'item',
            url: '/pre-cadastro-cliente',
            classes: 'nav-item',
            //icon: 'feather icon-sidebar'
          },
          {
            id: 'cadastro-cliente',
            title: 'Cadastrar',
            type: 'item',
            url: '/cadastro-cliente',
            classes: 'nav-item',
            //icon: 'feather icon-sidebar'
          }
        ]
      },      
      {
        id: 'auditoria-operadora',
        title: 'Auditorias',
        type: 'item',
        url: '/auditoria-operadora',
        classes: 'nav-item',
        icon: 'feather icon-sidebar'
      },
      {
        id: 'relatorio',
        title: 'Relatórios',
        type: 'item',
        url: '/relatorio',
        classes: 'nav-item',
        icon: 'feather icon-activity'
      },
      {
        id: 'comunicacao',
        title: 'Comunicação Geral',
        type: 'item',
        url: '/comunicacao',
        classes: 'nav-item',
        icon: 'feather icon-message-circle'
      },
      {
        id: 'agendamento',
        title: 'Agenda',
        type: 'item',  
        icon: 'feather icon-calendar', 
        url: '/agendamento',   
    
      }
    ]

  },  
  {
    id: 'Suporte',
    title: 'Suporte',
    type: 'collapse',  
    icon: 'feather icon-message-square', 
    children: [ 
      {
        id: 'Solicitar suporte',
        title: 'Solicitar suporte',
        type: 'item',
        url: '/Solicitar suporte',
        classes: 'nav-item',
      },

      {
        id: 'Manual de Preparação para Auditorias',
        title: 'Manual de Preparação para Auditorias',
        type: 'item',
        url: '/Manual de Preparação para Auditorias',
        classes: 'nav-item',
      }
    ]
  }
  

];

const NavigationItemsCliente = [
  {
    id: 'navigation',
    title: 'Perfil Cliente',
    type: 'group',
    icon: 'feather icon-align-left',
    children: [
      {
        id: 'home-cliente',
        title: 'Home',
        type: 'item',
        url: '/home-cliente',
        classes: 'nav-item',
        icon: 'feather icon-home'
      },
      {
        id: 'usuario-cliente',
        title: 'Usuários',
        type: 'item',
        url: '/usuario-cliente',
        classes: 'nav-item',
        icon: 'feather icon-users'
      },      
      {
        id: 'cronograma-a-fazer',
        title: 'Cronograma',
        type: 'item',
        url: '/cronograma-a-fazer',
        classes: 'nav-item',
        icon: 'feather icon-list'
      }, 
      {
        id: 'plano-acao',
        title: 'Plano de Ação',
        type: 'item',
        url: '/plano-acao',
        classes: 'nav-item',
        icon: 'feather icon-home'
      },   
      {
        id: 'auditoria-cliente',
        title: 'Auditoria',
        type: 'item',
        url: '/auditoria-cliente',
        classes: 'nav-item',
        icon: 'feather icon-file'
      },  
      {
        id: 'auditoria',
        title: 'Auditoria',
        type: 'collapse',  
        icon: 'feather icon-sidebar', 
        children: [ 
          
          {
            id: 'qualificacao-documental',
            title: 'Qualificação Documental',
            type: 'item',
            url: '/qualificacao-documental',
            classes: 'nav-item',
          },    
          {
            id: 'checklist-cliente',
            title: 'Checklist',
            type: 'item',
            url: '/checklist-cliente',
            classes: 'nav-item',
          },
          {
            id: 'relPorEtapa',
            title: 'Relatório por Etapa',
            type: 'item',
            url: '/relPorEtapa',
            classes: 'nav-item',
          },
          {
            id: 'docEvidencias',
            title: 'Documentos e Evidências',
            type: 'item',
            url: '/docEvidencias',
            classes: 'nav-item',
          },
          {
            id: 'gestConformidade',
            title: 'Gestão de Conformidade',
            type: 'item',
            url: '/gestConformidade',
            classes: 'nav-item',
          },
          {
            id: 'videos',
            title: 'Vídeos',
            type: 'item',
            url: '/videos',
            classes: 'nav-item',
          }
        ]
    
      },
      {
        id: 'visualizar-auditoria',
        title: 'Histórico Auditoria',
        type: 'item',
        url: '/visualizar-auditoria',
        classes: 'nav-item',
         icon: 'feather icon-home'
      }, 

    ]

  },
  {
    id: 'documento-apoio',
    title: 'Documentos de Apoio',
    type: 'item',
    url: '/documento-apoio',
    classes: 'nav-item',
    icon: 'feather icon-file'
  },
  {
    id: 'agendamento',
    title: 'Agenda',
    type: 'item',  
    icon: 'feather icon-calendar', 
    url: '/agendamento',   

  },
  {
    id: 'relFinal',
    title: 'Relatórios Final',
    type: 'item',
    url: '/relFinal',
    classes: 'nav-item',
    icon: 'feather icon-file'
  },
  {
    id: 'Suporte',
    title: 'Suporte',
    type: 'collapse',  
    icon: 'feather icon-message-square', 
    children: [ 
      {
        id: 'Solicitar suporte',
        title: 'Solicitar suporte',
        type: 'item',
        url: '/Solicitar suporte',
        classes: 'nav-item',
      },

      {
        id: 'Manual de Preparação para Auditorias',
        title: 'Manual de Preparação para Auditorias',
        type: 'item',
        url: '/Manual de Preparação para Auditorias',
        classes: 'nav-item',
      }
    ]

  },{
    id: 'Configurações',
    title: 'Configurações',
    type: 'collapse',  
    icon: 'feather icon-settings', 
    children: [ 
      {
        id: 'Gerenciar Usuários',
        title: 'Gerenciar Usuários',
        type: 'item',
        url: '/Gerenciar Usuários',
        classes: 'nav-item',
      },

      {
        id: 'Configurações de Notificações',
        title: 'Configurações de Notificações',
        type: 'item',
        url: '/Configurações de Notificações',
        classes: 'nav-item',
      },
      {
        id: 'Personalização do Perfil',
        title: 'Personalização do Perfil',
        type: 'item',
        url: '/Personalização do Perfil',
        classes: 'nav-item',
      }

    ]

  }

];

@Injectable()
export class NavigationItem {
  public get(ehTriagem: string) {
    /*if(ehTriagem == "Gestao")
      return NavigationItemsGestao;
    else
      return NavigationItemsGestao;*/

      switch(ehTriagem) {
        case "Gestao":
          return NavigationItemsGestao;
          break;
        case "Cliente":
          return NavigationItemsCliente;
          break;
        case "Operadora":
          return NavigationItemsOperadora;
            break;
        default:
          return NavigationItemsGestao;
      }
  }
  
}

export const navigation = [
  {
    id: 'cronograma-base',
    title: 'Cronograma Base',
    type: 'item',
    url: '/cronograma-base',
    classes: 'nav-item'
  },
  {
    id: 'cronograma-cliente',
    title: 'Cronograma Cliente',
    type: 'item',
    url: '/cronograma-cliente',
    classes: 'nav-item'
  },
  {
    id: 'usuario-cliente',
    title: 'Usuário Cliente',
    type: 'item',
    url: '/usuario-cliente',
    classes: 'nav-item'
  },
  {
    id: 'qualificacao-documental',
    title: 'Qualificação Documental',
    type: 'item',
    url: '/qualificacao-documental',
    classes: 'nav-item'
  },
  {
    id: 'checklist-cliente',
    title: 'Checklist Cliente',
    type: 'item',
    url: '/checklist-cliente',
    classes: 'nav-item'
  }
];

